import React from 'react';
import ScrollToTop from 'react-scroll-to-top';

const ScrollTop = () => {
    return (
        <>
            <ScrollToTop smooth color='#fff' style={{ background: "linear-gradient(192deg, #ff8c2e 0%, #7E2100 100%)", zIndex: 999 }} />
        </>
    );
};

export default ScrollTop;